import {trans} from '@frontend/helpers'
import clsx from 'clsx'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'

interface Props {
    label: string
    className?: string
    showResetButton?: boolean
    disabled?: boolean
    onReset?: () => void
}

// Название фильтра объявлений.
export function FilterLabel(props: Props) {

    const {
        label,
        className = 'mb-3',
        showResetButton,
        disabled,
        onReset,
    } = props

    return (
        <div
            className={clsx(
                'd-flex flex-row flex-wrap align-items-center col-gap-3 row-gap-2',
                className
            )}
        >
            <span className="fs-5 fw-800">{label}:</span>
            {onReset && showResetButton && !disabled && (
                <Button
                    color="gray"
                    outline
                    small
                    className="py-1 px-2 text-nowrap flex-shrink-0"
                    onClick={onReset}
                >
                    {trans().ads.list.filters.reset_filter}
                </Button>
            )}
        </div>
    )
}
